import { __assign } from "tslib";
import { useFeatureGates } from '@office-start/feature-gates-service';
import { useIdentity } from '@office-start/identity-service';
import { logFeature } from '@office-start/telemetry-service';
import { getLocation, getQueryParams } from '@office-start/url-parser-utility';
import { useCallback } from 'react';
export var PinnedSelectionTypes = {
    PinAndContinue: 'Pin and Continue',
    AskMeLater: 'Ask me later',
    Decline: 'Decline',
    Continue: 'Continue',
};
export var FreNotShownReasons = {
    ErrorInFetchingUserCopilotFreData: 'Error in fetching user copilot fre data',
    CopilotFreDisabled: 'Copilot fre is disabled',
    FrePreviouslyShownAndActionTaken: 'FRE previously shown and action taken',
    FreShownRecently: 'FRE shown recently',
    AdminStatusIsUnPinned: 'Admin status is unpinned',
    Unknown: 'Unknown',
};
export var CopilotRedirectionQueryParams = {
    redirectId: 'redirectId',
    fromCode: 'fromCode',
};
export var useCopilotFunnelLogging = function () {
    var _a, _b;
    var identity = useIdentity().data;
    var featureGates = useFeatureGates().data;
    var redirectIdQueryParam = 'redirectId';
    var logCopilotFunnelEvent = useCallback(function (eventName, params) {
        var _a, _b, _c, _d;
        var queryParams = getQueryParams(window.location.search);
        var RedirectId = (_a = queryParams[redirectIdQueryParam]) !== null && _a !== void 0 ? _a : '';
        var AADId = (_b = identity === null || identity === void 0 ? void 0 : identity.objectId) !== null && _b !== void 0 ? _b : '';
        var TenantId = (_c = identity === null || identity === void 0 ? void 0 : identity.tenantId) !== null && _c !== void 0 ? _c : '';
        var BaseUrl = window.location.origin;
        var updatedParams = __assign(__assign({}, params), { RedirectId: RedirectId, AADId: AADId, TenantId: TenantId, BaseUrl: BaseUrl });
        // log the event to otel only if the copilot fre feature gate is enabled
        if ((_d = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result.copilotFreGates) === null || _d === void 0 ? void 0 : _d.copilotFreEnabled) {
            logFeature({
                featureName: "CopilotPinFunnel" /* KnownFeatureNames.CopilotPinFunnel */,
                eventName: eventName,
                params: updatedParams,
            });
        }
    }, [
        (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result.copilotFreGates) === null || _a === void 0 ? void 0 : _a.copilotFreEnabled,
        identity === null || identity === void 0 ? void 0 : identity.objectId,
        identity === null || identity === void 0 ? void 0 : identity.tenantId,
    ]);
    var logSourceRedirectionFunnelEvent = useCallback(function (eventName, redirectionUrl, params) {
        var _a, _b, _c, _d, _e, _f, _g;
        var urlLocation = (_b = (_a = getLocation(redirectionUrl)) === null || _a === void 0 ? void 0 : _a.search) !== null && _b !== void 0 ? _b : '';
        var queryParams = getQueryParams(urlLocation);
        var RedirectId = (_c = queryParams[CopilotRedirectionQueryParams.redirectId]) !== null && _c !== void 0 ? _c : '';
        var RedirectionSourceApp = (_d = queryParams[CopilotRedirectionQueryParams.fromCode]) !== null && _d !== void 0 ? _d : '';
        var AADId = (_e = identity === null || identity === void 0 ? void 0 : identity.objectId) !== null && _e !== void 0 ? _e : '';
        var TenantId = (_f = identity === null || identity === void 0 ? void 0 : identity.tenantId) !== null && _f !== void 0 ? _f : '';
        var BaseUrl = window.location.origin;
        var updatedParams = __assign(__assign({}, params), { RedirectId: RedirectId, RedirectionSourceApp: RedirectionSourceApp, AADId: AADId, TenantId: TenantId, BaseUrl: BaseUrl });
        // log the event to otel only if the copilot fre feature gate is enabled
        if ((_g = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result.copilotFreGates) === null || _g === void 0 ? void 0 : _g.copilotFreEnabled) {
            logFeature({
                featureName: "CopilotPinFunnel" /* KnownFeatureNames.CopilotPinFunnel */,
                eventName: eventName,
                params: updatedParams,
            });
        }
    }, [
        (_b = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result.copilotFreGates) === null || _b === void 0 ? void 0 : _b.copilotFreEnabled,
        identity === null || identity === void 0 ? void 0 : identity.objectId,
        identity === null || identity === void 0 ? void 0 : identity.tenantId,
    ]);
    return [logCopilotFunnelEvent, logSourceRedirectionFunnelEvent];
};
//# sourceMappingURL=copilotLogUtils.js.map